import axios from '../plugins/axios';

const API_URL = '/admin/room-bookings';

export default {
  async getBookings(filters = {}) {
    let url = API_URL+`?_with_[payments]=&_with_[breaks]&_with_[details]=&_no_pagination_=1`;
    
    if (filters.customer) {
      url += `&_filters_[]=customer__contains&customer__contains=${encodeURIComponent(filters.customer)}`;
    }
    
    console.log('API Request URL:', url);
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async addBooking(bookingData) {
    // Create a copy to avoid modifying the original data
    const data = { ...bookingData };
    
    // Ensure dates are sent as strings in YYYY-MM-DD format
    if (Array.isArray(data.dates)) {
      data.dates = data.dates.map(date => {
        if (typeof date === 'string') {
          return date.split('T')[0]; // Remove any time component
        }
        return date;
      });
    }
    
    console.log('Sending booking data:', data);
    const response = await axios.post(API_URL, data);
    return response.data;
  },

  async updateBooking(bookingId, bookingData) {
    // Create a copy and fix dates
    const data = { ...bookingData };
    
    // Force dates into YYYY-MM-DD format
    if (Array.isArray(data.dates)) {
      data.dates = data.dates.map(date => {
        if (typeof date === 'string') {
          // Just take the first 10 characters which is YYYY-MM-DD
          return date.substring(0, 10);
        }
        return date;
      });
    }
    
    console.log('Sending update data:', data);
    const response = await axios.put(`${API_URL}/${bookingId}`, data);
    return response.data;
  },

  async deleteBooking(bookingId) {
    const response = await axios.delete(`${API_URL}/${bookingId}`);
    return response.data;
  },

  async fetchRoomBookingsWithDetails() {
    try {
      const response = await axios.get('/admin/room-bookings?_with_[details]=&_with_[breaks]&_no_pagination_=1');
      return response;
    } catch (error) {
      console.error('Error fetching room bookings with details:', error);
      throw error;
    }
  },
  
  async fetchCourseReservations() {
    try {
      const response = await axios.get('/admin/course-reservations');
      return response;
    } catch (error) {
      console.error('Error fetching course reservations:', error);
      throw error;
    }
  }
}; 